export default __webpack_public_path__ + "static/media/Blues.b27ec7eb.mp3";